import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import song from "../images/JSGIF Theme Song.mp3";
import { saveAs } from "file-saver";

const ThemeSong = () => {
  function downloader() {
    saveAs(song, "JSGIF Theme Song.mp3");
  }

  return (
    <div>
      <h1>JSGIF Theme Song</h1>
      <div
        className="ventureContainer"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <audio style={{ width: "100%" }} src={song} controls={true} />
        <Button
          className="btn--secondary"
          style={{ marginTop: "10px" }}
          onClick={() => downloader()}
        >
          Download
        </Button>
      </div>
    </div>
  );
};

export default ThemeSong;
